<template>
  <div>
    <div class="body">
      <van-image
        class="topLogo"
        :src="require('../../../../public/image/07/1.png')"
      ></van-image>
      <div class="bodywarp">
        <van-swipe
          :autoplay="3000"
          class="my-swipe"
          @change="onChange"
          ref="swiper"
        >
          <van-swipe-item v-for="item in swiperList" :key="item.image">
            <img @dragstart.prevent class="swiperImage1" :src="item.image" />
          </van-swipe-item>
          <template #indicator> <div></div> </template>
        </van-swipe>
      </div>
      <div class="indicatorWarp">
        <div class="indicator">
          <van-image
            @click="clickme(index)"
            v-for="(item, index) in swiperList"
            :key="index"
            class="round"
            :src="require('../../../../public/image/07/5.png')"
          >
          </van-image>
          <van-image
            ref="indicatorImage"
            class="indicatorImage"
            :src="require('../../../../public/image/07/4.png')"
          >
          </van-image>
        </div>
        <van-image
          class="readme"
          @click="show = true"
          :src="require('../../../../public/image/07/6.png')"
        >
        </van-image>
      </div>
      <div class="footer">
        <div class="left">
          <van-image :src="require('../../../../public/image/08/2.png')">
          </van-image>
        </div>
        <div class="right">
          <div class="rightText">
            <van-image :src="require('../../../../public/image/08/3.png')">
            </van-image>
            <van-image :src="require('../../../../public/image/08/4.png')">
            </van-image>
            <div class="rightFooter">
              <a
                href="https://www.facebook.com/CrossGate.TW/"
                target="_blank"
                rel="noopener noreferrer"
              ></a>
              <a
                href="https://www.lingluk.com/crossgate.tw/terms"
                target="_blank"
                rel="noopener noreferrer"
              ></a>
              <a
                href="https://www.lingluk.com/crossgate.tw/policy"
                target="_blank"
                rel="noopener noreferrer"
              ></a>
              <!-- <div @click="$router.push({ name: 'crossgate.tw' })"></div>
              <div @click="$router.push({ name: 'crossgate.terms' })"></div>
              <div @click="$router.push({ name: 'crossgate.policy' })"></div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <ReadmeDialog
      :titleImage="require('../../../../public/image/12/12/1.png')"
      :backgroundImage="require('../../../../public/image/12/12/4.png')"
      :removeImage="require('../../../../public/image/12/12/3.png')"
      :textImage="require('../../../../public/image/12/12/2.png')"
      :visible.sync="show"
      @changeVisible="show = !show"
    />
  </div>
</template>

<script>
import isMobile from '../../../../utils/isMobile.js'
import ReadmeDialog from '../components/readmeDialog/index.vue'

export default {
  components: {
    ReadmeDialog
  },
  data() {
    return {
      show: false,
      swiperList: [
        {
          image: require('../../../../public/image/11/01.jpg')
        },
        {
          image: require('../../../../public/image/11/02.jpg')
        },
        {
          image: require('../../../../public/image/11/03.jpg')
        },
        {
          image: require('../../../../public/image/11/04.jpg')
        },
        {
          image: require('../../../../public/image/11/05.jpg')
        },
        {
          image: require('../../../../public/image/11/06.jpg')
        },
        {
          image: require('../../../../public/image/11/KV.jpg')
        }
      ],
      isMobile: isMobile()
    }
  },
  methods: {
    clickme(index) {
      this.$refs.swiper.swipeTo(index)
    },
    onChange(index) {
      const indicatorImage = this.$refs.indicatorImage.$el
      indicatorImage.style['left'] =
        (180 / this.swiperList.length) * index + 'px'
    }
  }
}
</script>

<style lang="scss" scoped>
@keyframes heartbeat {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes heartbeat1 {
  0% {
    transform: translateY(0rem);
  }
  50% {
    transform: translateY(1rem);
  }
  100% {
    transform: translateY(0rem);
  }
}

.body {
  position: relative;
  width: 100%;
  background: url(../../../../public/image/10/07.jpg) no-repeat;
  background-size: 100% 100%;
  .bodywarp {
    background: url(../../../../public/image/07/2.png) no-repeat;
    background-size: 100% 100%;
    width: 300px;
    margin: 0 auto;
    padding: 1.5rem 0rem;
    .my-swipe {
      width: 90%;
      margin: auto;
    }
    .swiperImage1 {
      display: block;
      width: 100%;
      margin: auto;
      box-sizing: border-box;
    }
  }
  .topLogo {
    display: block;
    width: 80%;
    margin: 0 auto;
  }
  .indicatorWarp {
    margin-top: 20px;
    position: relative;
    .indicator {
      width: 180px;
      height: 10px;
      position: relative;
      margin: 0px auto;
      background-size: 100% 100%;
      box-sizing: border-box;
      display: flex;
      justify-content: space-around;
      .clikeDiv {
        height: 100%;
        width: 10px;
      }
      .round {
        vertical-align: middle;
        width: 10px;
        height: 10px;
      }
      .indicatorImage {
        width: calc(180px / 6);
        position: absolute;
        top: -1px;
        height: 12px;
        left: 0px;
      }
    }
    .readme {
      position: absolute;
      top: -2px;
      right: 20px;
      width: 50px;
      height: 14px;
    }
  }
  .footer {
    margin-top: 20px;
    height: 200px;
    width: 100%;
    background: url(../../../../public/image/08/1.png) no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: space-around;
    .left {
      width: 30%;
      position: relative;
      height: 100%;
      /deep/ .van-image {
        position: absolute;
        display: block;
        width: 60px;
        height: 60px;
        top: 24px;
        left: 50%;
        transform: translate(-50%, 0%);
      }
    }
    .right {
      width: 70%;
      .rightText {
        height: 80px;
        margin-top: 10px;
        /deep/ .van-image:nth-child(2) {
          width: 90%;
        }
        .rightFooter {
          background: url(../../../../public/image/08/5.png) no-repeat center;
          background-size: 100%;
          height: 20px;
          width: 50%;
          display: flex;
          justify-content: space-between;
          a {
            display: block;
            width: 30%;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/route/src/prereg/Activity07/index.vue